import { type ButtonType } from '@shared/utils/enums/button-type';

import { Button } from '../../../button/button';
import { ButtonVariant } from '../../../button/buttonVariant';

import styles from './dialog-actions.module.scss';

export type PrimaryButtonProps = {
  onPrimaryButtonClick?: () => void;
  primaryButtonDisabled?: boolean;
  primaryButtonForm?: string;
  primaryButtonLabel: string;
  primaryButtonType?: ButtonType;
};

export type SecondaryButtonProps = {
  onSecondaryButtonClick?: () => void;
  secondaryButtonLabel?: string;
};

export type DialogActionsProps = PrimaryButtonProps & SecondaryButtonProps;

export const DialogActions = ({
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonDisabled,
  primaryButtonForm,
  primaryButtonLabel,
  primaryButtonType,
  secondaryButtonLabel,
}: DialogActionsProps) => {
  return (
    <div className={styles['dialog-actions']}>
      {secondaryButtonLabel && onSecondaryButtonClick && (
        <Button onClick={onSecondaryButtonClick} variant={ButtonVariant.Secondary}>
          {secondaryButtonLabel}
        </Button>
      )}
      <Button
        disabled={primaryButtonDisabled}
        form={primaryButtonForm}
        onClick={onPrimaryButtonClick && onPrimaryButtonClick}
        type={primaryButtonType}
      >
        {primaryButtonLabel}
      </Button>
    </div>
  );
};
